import script from "./press-release.vue?vue&type=script&lang=js"
export * from "./press-release.vue?vue&type=script&lang=js"

import "./press-release.vue?vue&type=style&index=0&id=9943c6c4&lang=scss"

const __exports__ = script;

export default __exports__